<template>
  <Container :route-name="$route.name">
    <template #routerView>
      <router-view></router-view>
    </template>
  </Container>
</template>

<script>
const Container = () => import('@/modules/Login/LoginContainer')

export default {
  components: {
    Container
  }
}
</script>
